import { createFileRoute } from '@tanstack/react-router'
import ResetPasswordPage from '../../Pages/LoginPage/ResetPasswordPage'
import ErrorComponent from '../../Components/ErrorComponent'

export const Route = createFileRoute('/_public/reset-password')({
    component: Wrapper,
    errorComponent: ({ error, reset }) => {
        return <ErrorComponent error={error} reset={reset} />
    },
})

function Wrapper() {
    return (
        <>
            <ResetPasswordPage {...Route.useParams()} {...Route.useSearch()} />
        </>
    )
}
